import { jsx as e, jsxs as d, Fragment as k } from "react/jsx-runtime";
import { Formik as M } from "formik";
import x, { useState as H } from "react";
import I from "../Text/index.js";
import { TextArea as O } from "../TextArea/TextArea.js";
import R from "./FeedbackItem.js";
import S from "./ThankYou.js";
import { FeedbackWrapper as Q, IconsWrapper as T, Spacer as v, ButtonContainer as U, ButtonWrapper as j } from "./styled.js";
const X = x.forwardRef(
  function({
    onThumbSelect: c,
    onSkip: u,
    allowTextFeedback: n = !0,
    isGivenFeedback: t,
    feedbackType: r,
    isSent: p,
    locale: {
      completionText: o = "Thank you",
      prompt: h = "How was your experience?",
      thumbsUpLabel: y = "Good",
      thumbsDownLabel: m = "Bad",
      textAreaLabelGood: l = "Thank you, please tell us why (optional)",
      textAreaLabelBad: w = "How can we improve? (optional)",
      textAreaPlaceholder: b = "Don't include any confidential or personal info in your feedback. (No names, phone numbers or emails.)",
      submitActionLabel: i = "Send feedback",
      skipActionLabel: L = "Skip",
      privacyLinkLabel: V = "Privacy statement"
    } = {},
    onSubmit: g,
    disableFeedbackChange: _ = !1,
    feedbackTextAreaProps: D,
    thumbsUpProps: N,
    thumbsDownProps: Y,
    submitFeedbackProps: q,
    skipFeedbackProps: a,
    privacyLinkProps: z,
    as: W = "form"
  }, G) {
    const f = x.useRef(null), { wrapperProps: J, submitProps: K } = W === "form" ? { wrapperProps: { action: "#", onSubmit: g }, submitProps: { type: "submit" } } : { wrapperProps: {}, submitProps: { type: "button", onClick: g } }, B = (C) => {
      t && _ || (c && c(C), setTimeout(() => {
        var s;
        (s = f == null ? void 0 : f.current) == null || s.scrollIntoView({
          behavior: "smooth"
        });
      }, 10));
    };
    return p ? /* @__PURE__ */ e(S, { text: o }) : /* @__PURE__ */ d(W, { ...J, ref: G, children: [
      /* @__PURE__ */ e(I.Heading.H3, { fontWeight: 600, style: { marginBottom: "15px" }, children: h }),
      /* @__PURE__ */ d(Q, { children: [
        /* @__PURE__ */ d(T, { children: [
          /* @__PURE__ */ e(
            R,
            {
              direction: "up",
              onClick: () => B("up"),
              disabled: !!t && r !== "up",
              selected: r === "up",
              feedbackText: y,
              "data-testid": "feedback-thumbs-up",
              ...N
            }
          ),
          /* @__PURE__ */ e(
            R,
            {
              direction: "down",
              onClick: () => B("down"),
              disabled: !!t && r !== "down",
              selected: r === "down",
              feedbackText: m,
              "data-testid": "feedback-thumbs-down",
              ...Y
            }
          )
        ] }),
        t && !n && /* @__PURE__ */ d(k, { children: [
          /* @__PURE__ */ e(v, { space: 16 }),
          /* @__PURE__ */ e(S, { text: o })
        ] })
      ] }),
      t && n && /* @__PURE__ */ d(k, { children: [
        /* @__PURE__ */ e(v, { space: 30 }),
        /* @__PURE__ */ e(
          O,
          {
            label: r === "up" ? l : w,
            placeholder: b,
            maxLength: 300,
            ...D
          }
        ),
        /* @__PURE__ */ e(
          I.Link,
          {
            href: "https://service.vic.gov.au/privacy-and-security",
            "data-testid": "feedback-privacy-link",
            ...z,
            children: V
          }
        ),
        /* @__PURE__ */ e(v, { space: 24, ref: f }),
        /* @__PURE__ */ d(U, { children: [
          /* @__PURE__ */ e(
            j,
            {
              ...K,
              buttonType: "primary",
              "data-testid": "feedback-send",
              ...q,
              children: i
            }
          ),
          /* @__PURE__ */ e(
            j,
            {
              buttonType: "secondary",
              "data-testid": "feedback-skip",
              ...a,
              onClick: (C) => {
                var s;
                u && r && u(r), (s = a == null ? void 0 : a.onClick) == null || s.call(a, C);
              },
              children: L
            }
          )
        ] })
      ] })
    ] });
  }
), oe = x.forwardRef(
  function({ onFeedbackGiven: c, form: u, onThumbSelect: n, onSkip: t, ...r }, p) {
    const [o, h] = H({
      isGivenFeedback: !1
    }), [y, m] = H(!1);
    return /* @__PURE__ */ e(
      M,
      {
        initialValues: { feedback: "" },
        onSubmit: (l) => {
          m(!0), c && o.type && c(o.type, l.feedback);
        },
        ...u,
        children: ({ handleSubmit: l, handleChange: w, handleBlur: b }) => /* @__PURE__ */ e(
          X,
          {
            ref: p,
            onSubmit: l,
            onThumbSelect: (i) => {
              h({
                isGivenFeedback: !0,
                type: i
              }), n == null || n(i);
            },
            onSkip: (i) => {
              m(!0), t == null || t(i);
            },
            feedbackType: o.type,
            isGivenFeedback: o.isGivenFeedback,
            isSent: y,
            feedbackTextAreaProps: {
              name: "feedback",
              onChange: w,
              onBlur: b
            },
            ...r
          }
        )
      }
    );
  }
);
export {
  X as CompletionSurvey,
  oe as default
};
